import { render } from "./Alcool.vue?vue&type=template&id=65e6e63a&scoped=true"
import script from "./Alcool.vue?vue&type=script&lang=js"
export * from "./Alcool.vue?vue&type=script&lang=js"

import "./Alcool.vue?vue&type=style&index=0&id=65e6e63a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e6e63a"]])

export default __exports__